var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.562,
    height: 12,
    viewBox: "0 0 12.562 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49508",
    "data-name": "Group 49508",
    transform: "translate(547.941 105.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49507",
    "data-name": "Group 49507",
    transform: "translate(-547.941 -105.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93337",
    "data-name": "Path 93337",
    d: "M8.788,2.369,9.905,5.807a.534.534,0,0,0,.507.369h3.615a.533.533,0,0,1,.313.965L11.417,9.265a.533.533,0,0,0-.194.6L12.34,13.3a.534.534,0,0,1-.821.6L8.594,11.771a.533.533,0,0,0-.627,0L5.043,13.9a.534.534,0,0,1-.821-.6L5.339,9.862a.533.533,0,0,0-.194-.6L2.221,7.14a.533.533,0,0,1,.313-.965H6.149a.534.534,0,0,0,.507-.369L7.774,2.369A.533.533,0,0,1,8.788,2.369Z",
    transform: "translate(-2 -2)",
    fill: "#fca90d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b6cbe1f0de1c363dc8c9ff721fd942b0.svg";
export { ForwardRef as ReactComponent };